import { defineFcm } from '../shared/factory';

export const FCM_GROWTH_MEMBERSHIP_UI_UPDATE = defineFcm('growth_membership_ui_update')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'TBD',
		scope: 'corgi-front-end',
		context: 'PSF Membership Ask page',
		description: 'Rollout FCM for replacing the Super Signer membership ask UI with a more general UI',
		import: false,
	});
